/**
 * @generated SignedSource<<320f98a5ab8bce059cd197d4cc5aa2d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type usePermissionsQuery$variables = Record<PropertyKey, never>;
export type usePermissionsQuery$data = {
  readonly currentIAMUser: {
    readonly isIAMUser: boolean;
    readonly permissions: ReadonlyArray<string>;
  };
};
export type usePermissionsQuery = {
  response: usePermissionsQuery$data;
  variables: usePermissionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CurrentIAMUser",
    "kind": "LinkedField",
    "name": "currentIAMUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isIAMUser",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "permissions",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "usePermissionsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "usePermissionsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e333e4483f60ab63f280a326ce399ab6",
    "id": null,
    "metadata": {},
    "name": "usePermissionsQuery",
    "operationKind": "query",
    "text": "query usePermissionsQuery {\n  currentIAMUser {\n    isIAMUser\n    permissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c710f91d1ff1e19d32988d8d3b25ed1";

export default node;
